import React from 'react';
import "./scss/CustomSpacer.scss";

const CustomSpacer: React.FC = () => {
    return (
        <div style={{ width: '5vw' }} />
    );
}

export default CustomSpacer;